// scss
import "../scss/main.scss";

// js
import './animation.js';
